import type { GameMeta } from '@gmp/game-sdk';

export const meteorMayhemMeta = {
  id: 'meteor-mayhem',
  name: 'Meteor Mayhem',
  tagline: 'Dodge falling meteors and bump your friends off the Crater Carnival.',
  description:
    'Meteors land on marked spots after a clear warning. Steer, shove rivals into danger or off the edge, slide out of trouble. Five arenas (a crater, a doughnut round a pit, twin islands with a bridge, a spinning platform and a cross) rotate every round. Last bumper standing wins the round; the edge closes in halfway through.',
  minPlayers: 2,
  maxPlayers: 10,
  estimatedMinutes: [2, 4],
  usesMedia: false,
  modes: [
    { id: 'survival', name: 'Survival', description: 'Last bumper standing wins each round. A direct hit or a fall knocks you out.' },
    { id: 'casual', name: 'Casual', description: 'Health and quick respawns. Score knockouts for the whole timer.' },
  ],
  theme: { primary: '#ff4fd8', secondary: '#ffe14d', background: '#120a24', ink: '#fff2fb' },
  readiness: 'beta',
  genre: 'Arena knockout',
  controls: 'touch-action',
  category: 'versus',
  instructions: [
    { icon: 'Siren', title: 'Watch the rings', body: 'A striped ring with a countdown marks every meteor 1.5 s before it lands. Get out of it.' },
    { icon: 'Hand', title: 'Shove', body: 'Bump the nearest rival in front of you. Push them into a ring or over the edge.' },
    { icon: 'Zap', title: 'Slide', body: 'A quick dash that shoves can’t touch. Use it to escape.' },
    { icon: 'Target', title: 'New arena each round', body: 'Crater, Doughnut (mind the pit), Twin Isles (mind the bridge), Spin Cycle (it carries you round) and Crossroads.' },
    { icon: 'Trophy', title: 'Survive', body: 'Last one on the floor wins the round. The edge closes in halfway through.' },
  ],
} satisfies GameMeta;
